import { Box, Container, Grid } from "@mui/material";
import "./MsShimmer.css";
import { MsSpinnerMotion } from "../MsSpinnerMotion";
import { useAppTheme } from "../../theme/useTheme";
function MsShimmer() {
  const theme = useAppTheme();
  return (
    <Grid className="ms-set-password-container">
      <div className="ms-wl-bank-logo" data-testid="svg-icon">
        {theme?.assets?.logo && <img src={theme.assets.logo} alt="Worldline" />}
      </div>
      <Grid item xs={7} className="right-gradient" data-testid="right-gradient-circle">
        {theme?.assets?.rightCircle && <img src={theme.assets.rightCircle} alt="right-circular-gradient" />}
      </Grid>
      <div className="ms-set-password-left">
        <Container className="ms-form-container">
          <Box>
            <MsSpinnerMotion size="large" />
          </Box>
        </Container>
      </div>
    </Grid>
  );
}
export default MsShimmer;
